function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M15.667 3.667a1 1 0 00-1 1v12.666a1 1 0 001 1h1.666a1 1 0 001-1V4.667a1 1 0 00-1-1h-1.666zm-6.5 6.5a1 1 0 011-1h1.666a1 1 0 011 1v7.166a1 1 0 01-1 1h-1.666a1 1 0 01-1-1v-7.166zm-5.5 5.5a1 1 0 011-1h1.666a1 1 0 011 1v1.666a1 1 0 01-1 1H4.667a1 1 0 01-1-1v-1.666z"
});

var SvgPresentation = function SvgPresentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 22",
    fill: "none"
  }), _ref);
};

export default SvgPresentation;